import FormTitle from "../../components/helpers/FormTitle";
import { Box, Typography } from "@mui/material";

const NotAllowed = () => {
  return (
    <>
      <FormTitle title="Not allowed" />
      <Box>
        <Typography variant="h6" component="div">
          You are not allowed to access this page.
        </Typography>
      </Box>
    </>
  );
};

export default NotAllowed;
